import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { useSelectedReturnExchangesValueContextHook } from "../../../../contexts/SelectedReturnExchangesContext";
import { useEffect, useState } from "react";
import { useApiInfoContextValueHook } from "../../../../../../../contexts/ApiInfoContext";
import { SellertoolSignatureUtils } from "../../../../../../../utils/sellertool-signature-utils";
import { ReturnExchangeDownloadFormsApi } from "../../../../../../../apis/ReturnExchangeDownloadFormsApi";
import { FormControlLabel, FormGroup, Switch } from "@mui/material";
import { returnExchangeDownloadFormVariables } from "../../../../../variables/return-exchange-download-form-variables";
import { ModalMergeShipmentKeys } from "./modals/modal-merge-shipment-keys";
import CustomSelect from "../../../../../../../components/select/default/v1/CustomSelect";
import CustomBlockButton from "../../../../../../../components/button/CustomBlockButton";
import { ProductOptionsApi } from "../../../../../../../apis/ProductOptionsApi";
import _ from "lodash";
import { customToast } from "../../../../../../../components/toast/custom-react-toastify/v1";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import moment from "moment";
import { CustomBackdropController } from "../../../../../../../components/backdrop/default/v1";

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    .switch-label{
        font-size: 14px;
        font-weight: 500;
    }

    .mergeShipmentKeys-box{
        display: flex;
        gap: 5px;
        align-items: center;
        margin-top: 10px;
        .mergeShipmentKeys-item{
            font-size: 12px;
            font-weight: 600;
        }

        .mergeShipmentKeys-setting-button{
            border: 1px solid #333;
            padding: 3px 8px;
            border-radius: 3px;
            font-size: 12px;
            font-weight: 600;
            background: #fff;
            cursor: pointer;
        }
    }

    .select-download-form-box{
        margin-top: 20px;
        .title{
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 10px;
        }

        select{
            width: 200px;
        }
    }
`;

const StyledExcelDatasBody = styled.div`
    padding: 10px;
`;

const StyledTableContainer = styled.div`
  overflow-x: auto;
  margin: 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 100%;
  height: 300px;
  border: 1px solid #efefef;
`;

const StyledTable = styled.table`
  table-layout: auto;    /* 내용 길이에 맞춰 열 너비 자동 */
  white-space: nowrap;   /* 한 줄로 표시하여 열이 자동 확장 */
  border-collapse: collapse;
  background-color: #ffffff;

  /* width: 100%;  <-- 필요한 경우 제거하거나 조정
     min-width: 800px; <-- 원한다면 유지 (너무 좁아지지 않게)
  */
`;

const StyledTableHeader = styled.thead`
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f8f9fa;
`

const StyledTableHeaderCell = styled.th`
    padding: 16px;
    text-align: left;
    font-weight: 600;
    color: #495057;
    border-bottom: 2px solid #dee2e6;
    white-space: nowrap;
    font-size: 12px;
`

const StyledTableRow = styled.tr`
    &:nth-child(even) {
        background-color: #f8f9fa;
    }
    
    &:hover {
        background-color: #e9ecef;
    }

    &.selected{
        background-color:rgb(231, 238, 244) !important;
    }
`

const StyledTableCell = styled.td`
    padding: 16px;
    color: #495057;
    border-bottom: 1px solid #dee2e6;
    font-size: 12px;
    //wrap 허용
    white-space: pre-wrap;
    word-break: break-all;

    .view-button{
        background-color: var(--blueColor1);
        color: #fff;
        border-radius: 3px;
        border:none;
        height: 30px;
        padding: 0 10px;
        font-weight: 600;
        cursor: pointer;
    }
`

const StyledFooter = styled.div`
    padding: 10px;
    button{
        border-radius: 3px;
        border: none;
        background: #333;
        color: #fff;
        font-weight: 600;
    }
`;

export function ModalExcelDownload({
    open,
    onClose
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const selectedReturnExchangesValueContextHook = useSelectedReturnExchangesValueContextHook();
    const selectedReturnExchanges = selectedReturnExchangesValueContextHook.selectedReturnExchanges;

    const [returnExchangeDownloadForms, setReturnExchangeDownloadForms] = useState([]);
    const [selectedReturnExchangeDowloadForm, setSelectedReturnExchangeDowloadForm] = useState(null);

    const [mergeShipmentFlag, setMergeShipmentFlag] = useState(true);
    const [mergeShipmentKeys, setMergeShipmentKeys] = useState(['exchangeReShipmentReceiver', 'exchangeReShipmentDestination', 'exchangeReShipmentDestinationDetail']);
    const [mergeShipmentKeysModalOpen, setMergeShipmentKeysModalOpen] = useState(false);

    const [productOptions, setProductOptions] = useState(null);

    const [reformedReturnExchanges, setReformedReturnExchanges] = useState(null);
    const [viewType, setViewType] = useState('NORMAL'); // NORMAL, RESULT
    const [excelDatas, setExcelDatas] = useState(null);

    // 다운로드 폼 가져오기
    useEffect(() => {
        handleReqFetchReturnExchangeDownloadForms();
    }, []);

    // 상품 정보 가져오기
    useEffect(() => {
        if (!selectedReturnExchanges || selectedReturnExchanges?.length <= 0) {
            return;
        }
        handleReqProductOptions();
    }, [selectedReturnExchanges]);

    useEffect(() => {
        if (!productOptions) {
            return;
        }

        let newReturnExchanges = _.cloneDeep(selectedReturnExchanges);

        newReturnExchanges.forEach(r => {
            const originOrderProductOption = productOptions.find(p => p.code === r?.releaseOptionCode);
            const exchangeReShipmentOrderProductOption = productOptions.find(p => p.code === r?.exchangeReleaseOptionCode);

            if (originOrderProductOption) {
                r['originOrder$productName'] = originOrderProductOption?.product?.name || '';
                r['originOrder$productTag'] = originOrderProductOption?.product?.productTag || '';
                r['originOrder$productOptionName'] = originOrderProductOption?.name || '';
                r['originOrder$productOptionTag'] = originOrderProductOption?.optionTag || '';
            } else {
                r['originOrder$productName'] = '';
                r['originOrder$productTag'] = '';
                r['originOrder$productOptionName'] = '';
                r['originOrder$productOptionTag'] = '';
            }

            if (exchangeReShipmentOrderProductOption) {
                r['exchangeReShipmentOrder$productName'] = exchangeReShipmentOrderProductOption?.product?.name || '';
                r['exchangeReShipmentOrder$productTag'] = exchangeReShipmentOrderProductOption?.product?.productTag || '';
                r['exchangeReShipmentOrder$productOptionName'] = exchangeReShipmentOrderProductOption?.name || '';
                r['exchangeReShipmentOrder$productOptionTag'] = exchangeReShipmentOrderProductOption?.optionTag || '';
            } else {
                r['exchangeReShipmentOrder$productName'] = '';
                r['exchangeReShipmentOrder$productTag'] = '';
                r['exchangeReShipmentOrder$productOptionName'] = '';
                r['exchangeReShipmentOrder$productOptionTag'] = '';
            }

            setReformedReturnExchanges(newReturnExchanges);
        });

    }, [productOptions]);

    const handleReqFetchReturnExchangeDownloadForms = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const response = await ReturnExchangeDownloadFormsApi().searchList({ headers: headers });

        if (response?.content) {
            setReturnExchangeDownloadForms(response?.content);
        }
    }

    const handleReqProductOptions = async () => {
        const optionCodes = [...new Set(selectedReturnExchanges?.reduce((acc, cur) => {
            if (cur?.releaseOptionCode) {
                acc.push(cur?.releaseOptionCode);
            }

            if (cur?.exchangeReleaseOptionCode) {
                acc.push(cur?.exchangeReleaseOptionCode);
            }

            return acc;
        }, []))];

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            optionCodes: optionCodes
        }

        const response = await ProductOptionsApi().searchListByOptionCodes({ headers: headers, body: body });

        if (response?.content) {
            setProductOptions(response?.content);
        }
    }

    const handleChangeMergeShipmentFlag = () => {
        setMergeShipmentFlag(prev => !prev);
    }

    const handleChangeReturnExchangeDownloadForm = (e) => {
        const value = e.target.value;
        if (!value) {
            setSelectedReturnExchangeDowloadForm(null);
            return;
        }

        setSelectedReturnExchangeDowloadForm(returnExchangeDownloadForms.find(r => r._id === e.target.value));
    }

    const handleCreateExcelForm = () => {
        if (!selectedReturnExchangeDowloadForm) {
            customToast.error('다운로드 폼을 선택해주세요.');
            return;
        }

        const excelDatas = makeExcelDatas(selectedReturnExchangeDowloadForm?.items, reformedReturnExchanges, mergeShipmentFlag, mergeShipmentKeys);
        setExcelDatas(excelDatas);
        handleChangeViewType('RESULT');
    }

    const handleChangeViewType = (viewType) => {
        if (viewType === 'NORMAL') {
            setExcelDatas(null);
        }
        setViewType(viewType);
    }

    const handleDownloadExcel = async () => {
        const currentDateTime = moment().format('YYYYMMDDHHmmss');
        CustomBackdropController().showBackdrop();
        await exportStyledExcel(excelDatas, `${selectedReturnExchangeDowloadForm?.name}_${currentDateTime}.xlsx`);
        CustomBackdropController().hideBackdrop();
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
                maxWidth="xl"
            >
                {viewType === 'NORMAL' &&
                    <>
                        <StyledHeader>
                            <CustomDialog.Header>
                                <CustomDialog.Header.Fake />
                                <CustomDialog.Header.Title>
                                    엑셀 다운로드
                                </CustomDialog.Header.Title>
                                <CustomDialog.Header.Close onClick={onClose} />
                            </CustomDialog.Header>
                        </StyledHeader>
                        <StyledBody>
                            <div>
                                <FormGroup style={{ width: 'fit-content' }}>
                                    <FormControlLabel control={<Switch checked={mergeShipmentFlag} onChange={handleChangeMergeShipmentFlag} />} label={(<div className='switch-label'>합배송 설정</div>)} />
                                </FormGroup>
                                {mergeShipmentFlag &&
                                    <div className='mergeShipmentKeys-box'>
                                        <div className='mergeShipmentKeys-item'>합배송 조건 : </div>
                                        {mergeShipmentKeys.map((key, index) => {
                                            const downloadFormVariable = returnExchangeDownloadFormVariables.find(r => r.fieldName === key);
                                            return (
                                                <div key={key} className='mergeShipmentKeys-item'>"{downloadFormVariable?.label}"</div>
                                            )
                                        })}
                                        <button type='button' className='mergeShipmentKeys-setting-button' onClick={() => setMergeShipmentKeysModalOpen(true)}>설정</button>
                                    </div>
                                }
                            </div>
                            <div className='select-download-form-box'>
                                <div className='title'>
                                    다운로드 폼 선택
                                </div>
                                <CustomSelect value={selectedReturnExchangeDowloadForm?._id} onChange={(e) => handleChangeReturnExchangeDownloadForm(e)}>
                                    <option value={''}>선택</option>
                                    {returnExchangeDownloadForms.map((r, index) => {
                                        return (
                                            <option key={r._id} value={r._id}>{r.name}</option>
                                        )
                                    })}
                                </CustomSelect>
                            </div>
                        </StyledBody>
                        <StyledFooter>
                            <CustomBlockButton
                                type='button'
                                onClick={() => handleCreateExcelForm()}
                            >
                                엑셀 폼 생성
                            </CustomBlockButton>
                        </StyledFooter>
                    </>
                }
                {viewType === 'RESULT' &&
                    <>
                        <StyledHeader>
                            <CustomDialog.Header>
                                <CustomDialog.Header.Back onClick={() => handleChangeViewType('NORMAL')} />
                                <CustomDialog.Header.Title>
                                    엑셀 다운로드
                                </CustomDialog.Header.Title>
                                <CustomDialog.Header.Close onClick={onClose} />
                            </CustomDialog.Header>
                        </StyledHeader>
                        <StyledExcelDatasBody>
                            <StyledTableContainer>
                                <StyledTable>
                                    <StyledTableHeader>
                                        <tr>
                                            {excelDatas[0]?.map((r, index) => {
                                                return (
                                                    <StyledTableHeaderCell key={index}>{r}</StyledTableHeaderCell>
                                                )
                                            })}
                                        </tr>
                                    </StyledTableHeader>
                                    <tbody>
                                        {excelDatas?.slice(1)?.map((excelData, index) => {
                                            return (
                                                <StyledTableRow key={index}>
                                                    {excelData.map((r, index) => {
                                                        return (
                                                            <StyledTableCell key={index}>{r}</StyledTableCell>
                                                        )
                                                    })}
                                                </StyledTableRow>
                                            );
                                        })}
                                    </tbody>
                                </StyledTable>
                            </StyledTableContainer>
                        </StyledExcelDatasBody>
                        <StyledFooter>
                            <CustomBlockButton
                                type='button'
                                onClick={() => handleDownloadExcel()}
                            >
                                엑셀 다운로드
                            </CustomBlockButton>
                        </StyledFooter>
                    </>
                }
            </CustomDialog>

            {mergeShipmentKeysModalOpen &&
                <ModalMergeShipmentKeys
                    open={mergeShipmentKeysModalOpen}
                    onClose={() => setMergeShipmentKeysModalOpen(false)}
                    mergeShipmentKeys={mergeShipmentKeys}
                    onConfirm={(values) => setMergeShipmentKeys(values)}
                />
            }
        </>
    );
}

function makeExcelDatas(excelHeaderDetails, returnExchanges, mergeShipmentFlag, mergeShipmentKeys) {
    let excelDatas = [];
    excelDatas.push(excelHeaderDetails.map(r => r.cellName));

    if (mergeShipmentFlag) {
        // mergeShipmentKeys를 기준으로 returnExchanges를 재정렬
        let newReturnExchanges = _.cloneDeep(returnExchanges);
        newReturnExchanges.sort((a, b) => {
            let aValue = mergeShipmentKeys.reduce((acc, cur) => {
                acc.push(a[cur]);
                return acc;
            }, []);

            let bValue = mergeShipmentKeys.reduce((acc, cur) => {
                acc.push(b[cur]);
                return acc;
            }, []);

            let str1 = aValue.join('');
            let str2 = bValue.join('');
            return str1 < str2 ? -1 : str1 > str2 ? 1 : 0;
        })

        let combinedReturnExchanges = [];

        // mergeShipmentKeys를 기준으로 returnExchanges를 합침
        newReturnExchanges.forEach((r, index) => {
            const prev = newReturnExchanges[index - 1];
            if (prev) {
                let isSame = mergeShipmentKeys.every(key => {
                    return r[key] === prev[key];
                });

                if (isSame) {
                    combinedReturnExchanges[combinedReturnExchanges.length - 1].push(r);
                } else {
                    combinedReturnExchanges.push([r]);
                }
            } else {
                combinedReturnExchanges.push([r]);
            }
        });

        // excelHeaderDetails 를 기준으로 테이블의 body를 구성
        combinedReturnExchanges.forEach(combinedReturnExchangeCollection => {
            let values = []
            excelHeaderDetails?.forEach(headerDetail => {
                let value = '';
                if (headerDetail?.valueType === 'FREIGHT_CODE') {
                    let tempValueList = combinedReturnExchangeCollection?.reduce((acc, cur) => {
                        if (cur?.freightCode) {
                            acc.push(cur?.freightCode);
                        }
                        return acc;
                    }, []);
                    value = tempValueList && tempValueList?.length > 0 ? tempValueList?.join(',') : '';
                    values.push(value);
                    return;
                }

                if (headerDetail?.valueType === 'FIXED') {
                    if (headerDetail?.mergeableFlag) {
                        let tempValueList = combinedReturnExchangeCollection?.reduce((acc, cur) => {
                            if (headerDetail?.fixedValue) {
                                acc.push(headerDetail?.fixedValue);
                            }
                            return acc;
                        }, []);
                        value = tempValueList && tempValueList?.length > 0 ? tempValueList?.join(headerDetail?.mergeSeparator) : '';
                        values.push(value);
                    } else {
                        value = headerDetail?.fixedValue || '';
                        values.push(value);
                    }
                    return;
                }

                if (headerDetail?.valueType === 'NORMAL') {
                    if (headerDetail?.mergeableFlag) {
                        let mergedTempValueList = [];
                        combinedReturnExchangeCollection?.forEach(returnExchange => {
                            let tempValueList = headerDetail?.fieldNames?.reduce((acc, cur) => {
                                if (returnExchange[cur]) {
                                    acc.push(returnExchange[cur]);
                                }
                                return acc;
                            }, []);
                            mergedTempValueList.push(tempValueList && tempValueList?.length > 0 ? tempValueList?.join(headerDetail?.valueSeparator) : '');
                        })

                        value = mergedTempValueList && mergedTempValueList?.length > 0 ? mergedTempValueList?.join(headerDetail?.mergeSeparator) : '';
                        values.push(value);
                    } else {
                        let tempValueList = headerDetail?.fieldNames?.reduce((acc, cur) => {
                            if (combinedReturnExchangeCollection[0][cur]) {
                                acc.push(combinedReturnExchangeCollection[0][cur]);
                            }
                            return acc;
                        }, []);
                        value = tempValueList && tempValueList?.length > 0 ? tempValueList?.join(headerDetail?.valueSeparator) : '';
                        values.push(value);
                    }
                }
            })
            excelDatas.push(values);
        })
    } else {
        // excelHeaderDetails 를 기준으로 테이블의 body를 구성
        returnExchanges.forEach(returnExchange => {
            let values = []
            excelHeaderDetails?.forEach(headerDetail => {
                let value = '';
                if (headerDetail?.valueType === 'FREIGHT_CODE') {
                    value = returnExchange?.freightCode || '';
                    values.push(value);
                    return;
                }

                if (headerDetail?.valueType === 'FIXED') {
                    value = headerDetail?.fixedValue || '';
                    values.push(value);
                    return;
                }

                if (headerDetail?.valueType === 'NORMAL') {
                    let tempValueList = headerDetail?.fieldNames?.reduce((acc, cur) => {
                        if (returnExchange[cur]) {
                            acc.push(returnExchange[cur]);
                        }
                        return acc;
                    }, []);
                    value = tempValueList && tempValueList?.length > 0 ? tempValueList?.join(headerDetail?.valueSeparator) : '';
                    values.push(value);
                }
            })
            excelDatas.push(values);
        })
    }

    return excelDatas;
}

async function exportStyledExcel(data, fileName = "export.xlsx") {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    // 데이터 추가 (2차원 배열)
    data.forEach((row, rowIndex) => {
        const excelRow = worksheet.addRow(row);
        // 예: 첫 행을 헤더로 스타일 지정
        if (rowIndex === 0) {
            excelRow.eachCell((cell) => {
                cell.font = { bold: true, name: "Arial", size: 12 };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'efefef' },
                };
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
        }
    });

    // 각 열의 최대 텍스트 길이를 계산하여 열 너비 설정
    worksheet.columns.forEach((column) => {
        let maxLength = 10; // 기본 너비 설정 (예: 10)
        column.eachCell({ includeEmpty: true }, (cell) => {
            const cellValue = cell.value ? cell.value.toString() : "";
            if (cellValue.length * 1.4 > maxLength) {
                maxLength = cellValue.length * 1.4;
            }
        });
        // 약간의 여유 공간을 위해 +2 정도를 추가할 수 있음
        column.width = maxLength + 5;
    });

    // 워크북을 버퍼로 작성
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    saveAs(blob, fileName);
}